import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { InActiveDiningTable } from '../../Redux/ActiveStore/activeStoreSlice';

interface TableMoveDialogProps {
  open: boolean;
  fromTableName: string;
  destinations: InActiveDiningTable[];
  onClose: () => void;
  onMove: (toDiningTableId: string) => void;
}

// テーブル移動（ADR 0040）: 移動先は非稼働中テーブルのみ選択可
const TableMoveDialog: React.FC<TableMoveDialogProps> = ({
  open,
  fromTableName,
  destinations,
  onClose,
  onMove,
}) => {
  const [toDiningTableId, setToDiningTableId] = useState<string>('');

  const handleClose = () => {
    setToDiningTableId('');
    onClose();
  };

  const handleMove = () => {
    if (!toDiningTableId) return;
    onMove(toDiningTableId);
    setToDiningTableId('');
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="table-move-dialog"
      PaperProps={{ sx: { minWidth: '390px' } }}
    >
      <DialogTitle id="table-move-dialog">テーブル移動</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {fromTableName} の注文・会計を移動先のテーブルに引き継ぎます。
        </Typography>
        {destinations.length ? (
          <RadioGroup
            value={toDiningTableId}
            onChange={(e) => setToDiningTableId(e.target.value)}
          >
            {destinations.map((table) => (
              <FormControlLabel
                key={table.diningTable.id}
                value={table.diningTable.id}
                control={<Radio />}
                label={table.diningTable.name}
              />
            ))}
          </RadioGroup>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            移動先にできる非稼働中のテーブルがありません。
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1, justifyContent: 'space-between' }}>
        <Button sx={{ width: '49%' }} onClick={handleClose} color="inherit" variant="outlined">
          キャンセル
        </Button>
        <Button
          sx={{ width: '49%' }}
          onClick={handleMove}
          color="primary"
          variant="contained"
          disabled={!toDiningTableId}
        >
          移動
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TableMoveDialog;
